import styled from 'styled-components';
import { Colors } from '../../../../../../constants/Colors';
import { Button } from '@mui/material';

export const VolumeListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
`;

export const Title = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`;

export const Item = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ccc;
  &:hover {
    background: ${Colors.GREY_100};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 40px;
  flex: 1 0 0;
`;

export const FirstContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;

export const SerialText = styled.div`
  color: var(--luft-secondary-darker);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const LastRegistration = styled.span`
  color: var(--text-secondary-54-p, rgba(0, 0, 0, 0.54));
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.15px;
`;

export const DateText = styled.span`
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.15px;
  margin-left: 5px;
`;

export const SecondContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  gap: 8px;
`;

export const AverageTemperatureTitle = styled.div`
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  line-height: 20px;
`;

export const ChartContainer = styled.div`
  display: flex;
`;

export const AverageTemperature = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin-left: 5px;
`;

export const DetailsContainer = styled(Button)`
  color: var(--luft-primary);
  font-weight: 500;
  text-transform: none;
  gap: 8px;
`;

export const Details = styled.div`
  display: flex;
  align-items: normal;
  gap: 4px;
`;

export const LoadingContainer = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
